import React from 'react';

import type { UiEntitySpec } from '../config/uiSpec';

import type { EntityFormScreenProps } from './EntityFormScreen';
import { EntityFormScreen } from './EntityFormScreen';

export interface EntityCreateScreenProps
  extends Omit<EntityFormScreenProps, 'mode' | 'id'> {
  entitySpec: UiEntitySpec;
  initialValues?: Record<string, unknown>;
}

export function EntityCreateScreen(props: EntityCreateScreenProps): JSX.Element {
  return <EntityFormScreen {...props} mode="create" />;
}
